import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { HexToRgb } from '../utilities';

const Dropdown = styled.div`
  background-color: ${props => props.theme.carvana.white.primary};
  display: none;
  box-shadow: 3px 2px 31px 1px rgba(${props => HexToRgb(props.theme.carvana.blue.dark)}, 0.33);
  position: absolute;
  top: 35px;
  z-index: 1;

  p {
    margin-top: 0;
  }

  @supports (filter: blur()) {
    box-shadow: none;
    filter: drop-shadow(3px 2px 8px rgba(${props => HexToRgb(props.theme.carvana.blue.dark)}, 0.33));
  }

  &:before {
    content: "";
    display: block;
    height: 25px;
    position: absolute;
    top: -25px;
    width: 100%;
  }

  &:after {
    top: -20px;
    right: 10px;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-bottom-color: ${props => props.theme.carvana.white.primary};
    border-width: 10px;
  }
`;

const DropdownContent = props => (
  <Dropdown {...props} className={`dropdown ${props.className}`}>
    {props.children}
  </Dropdown>
);

DropdownContent.defaultProps = {
  children: null,
  className: '',
};

DropdownContent.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default DropdownContent;
